/**
 * @file
 * Standard collections to use anywhere
 */

import {Collection, ID, IResource, ObjectCollection, WholeCollection} from 'simpli-web-sdk'
import moment from 'moment'
import {AppConfig} from '@/config/app.config'
import {Region} from '@/enums/Region'
import {UF} from '@/enums/UF'
import {UFInitial} from '@/enums/UFInitial'
import {Period} from '@/enums/Period'
import {GroupBy} from '@/enums/GroupBy'
import {DeliveryStatus} from '@/enums/DeliveryStatus'
import {DeliveryEvent} from '@/enums/DeliveryEvent'
import {DeliveryAudit} from '@/enums/DeliveryAudit'
import {DeliverySlaStatus} from '@/enums/DeliverySlaStatus'
import {DeliveryDriverStatus} from '@/enums/DeliveryDriverStatus'
import {TipoVeiculo} from '@/enums/TipoVeiculo'
import {MarcaVeiculo} from '@/enums/MarcaVeiculo'
import {TipoCarroceria} from '@/enums/TipoCarroceria'
import Motorista from '@/model/resource/Motorista'
import CargaDestinatario from '@/model/resource/CargaDestinatario'
import ResponsavelCollection from '@/model/collection/ResponsavelCollection'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'
import Responsavel from '@/model/resource/Responsavel'
import CargaCollection from '@/model/collection/CargaCollection'
import {Transhipment} from '@/enums/Transhipment'
import OcorrenciaTracking from '@/model/resource/OcorrenciaTracking'
import CentroDeCusto from '@/model/resource/CentroDeCusto'
import AuditoriaMotivo from '@/model/resource/AuditoriaMotivo'
import TipoChecklistEntrega from '@/model/resource/TipoChecklistEntrega'
import TipoCnpjFuncao from '@/model/resource/TipoCnpjFuncao'
import Insumo from '@/model/resource/Insumo'
import {TipoSistema} from '@/enums/TipoSistema'
import {DeliveryAuditGeo} from '@/enums/DeliveryAuditGeo'
import {GroupByNoDefault} from '@/enums/GroupByNoDefault'
import EmailNivel from '@/model/resource/EmailNivel'
import TipoOcorrenciaSucesso from '@/model/resource/TipoOcorrenciaSucesso'
import StatusNotificacaoAuditoria from '@/model/resource/StatusNotificacaoAuditoria'
import { TipoNotificacaoCarga } from '@/enums/TipoNotificacaoCarga'

export abstract class ItrackCollection {
  static get allResponsavel() {
    return new ResponsavelCollection()
  }
  static get allResponsavelEmbarcador() {
    return new ResponsavelCollection({}, '/user/me/embarcador')
  }
  static get allResponsavelMotorista() {
    return new ResponsavelCollection({}, '/user/me/motorista')
  }
  static get allSigla() {
      return new CargaCollection({}, '/user/me/sigla')
  }
  static get allFilial() {
    const collection = new Collection(Responsavel)
    collection.endpoint = '/user/me/responsavel-filial'
    return collection
  }
  static get allFilialFilter() {
    const collection = new Collection(Responsavel)
    collection.endpoint = '/user/me/responsavel-filial/filtro'
    return collection
  }
  static get allMotorista() {
    return new WholeCollection(Motorista)
  }
  static get allMotoristaFiltro() {
    const collection = new WholeCollection(Motorista)
    collection.endpoint = '/user/motorista/filtro'
    return collection
  }
  static get allMotoristaSimplifiedList() {
    const collection = new WholeCollection(Motorista)
    collection.endpoint = '/user/motorista/lista-simplificada'
    return collection
  }
  static get allMotoristasOfReport() {
    const collection = new Collection(Motorista)
    collection.endpoint = '/user/motorista/relatorio'
    return collection
  }
  static get allCentroDeCusto() {
    const collection = new WholeCollection(CentroDeCusto)
    collection.endpoint = '/user/me/centro-de-custo'
    return collection
  }
  static get allTipoInsumo() {
      const collection = new WholeCollection(Insumo)
      collection.endpoint = '/user/me/tipo-de-insumo'
      return collection
  }
  static get allAuditoriaMotivo() {
    const collection = new WholeCollection(AuditoriaMotivo)
    collection.endpoint = '/user/auditoria-motivo'
    return collection
  }
  static get allAuditoriaMotivoFiltro() {
    const collection = new WholeCollection(AuditoriaMotivo)
    collection.endpoint = '/user/auditoria-motivo/filtro'
    return collection
  }
  static get allReceiver() {
    return new WholeCollection(CargaDestinatario)
  }
  static get allTipoOcorrencia() {
    return new WholeCollection(TipoOcorrencia)
  }
  static get allTipoOcorrenciaFiltro() {
    const collection = new WholeCollection(TipoOcorrencia)
    collection.endpoint = '/user/tipo-ocorrencia/filtro'
    return collection
  }

  static get allTipoChecklist() {
      return new WholeCollection(TipoChecklistEntrega)
  }

    static get allTipoCnpjBulklog() {
        return new WholeCollection(TipoCnpjFuncao)
    }

  static get allTipoOcorrenciaResponsavel() {
    const collection = new WholeCollection(TipoOcorrencia)
    collection.endpoint = '/user/tipo-ocorrencia/responsavel'
    return collection
  }

  static get allTipoOcorrenciaEnd() {
      const collection = new WholeCollection(TipoOcorrencia)
      collection.endpoint = '/user/tipo-ocorrencia/end'
      return collection
  }
  static get allTipoOcorrenciaSucessoEnd() {
    const collection = new WholeCollection(TipoOcorrenciaSucesso)
    collection.endpoint = '/user/tipo-ocorrencia-sucesso/end'
    return collection
  }
  static get allOcorrenciaTracking() {
    return new WholeCollection(OcorrenciaTracking)
  }
  static get allPeriod() {
    return new ObjectCollection(Period, 'enums.Period')
  }
  static get allGroupBy() {
    return new ObjectCollection(GroupBy, 'enums.GroupBy')
  }
    static get allGroupByNoDefault() {
        return new ObjectCollection(GroupByNoDefault, 'enums.GroupByNoDefault')
    }
  static get allRegion() {
    return new ObjectCollection(Region, 'enums.Region')
  }
  static get allUF() {
    return new ObjectCollection(UF, 'enums.UF')
  }
  static get allUFInitial() {
    return new ObjectCollection(UFInitial, 'enums.UFInitial')
  }
  static get allSistema() {
      return new ObjectCollection(TipoSistema, 'enums.TipoSistema')
  }
  static get allStatus() {
    return new ObjectCollection(DeliveryStatus, 'enums.DeliveryStatus')
  }
  static get allEvent() {
    return new ObjectCollection(DeliveryEvent, 'enums.DeliveryEvent')
  }
  static get allAudit() {
    return new ObjectCollection(DeliveryAudit, 'enums.DeliveryAudit')
  }
  static get allAuditGeo() {
      return new ObjectCollection(DeliveryAuditGeo, 'enums.DeliveryAuditGeo')
  }
  static get allSlaStatus() {
    return new ObjectCollection(DeliverySlaStatus, 'enums.DeliverySlaStatus')
  }
  static get allTranshipment() {
    return new ObjectCollection(Transhipment, 'enums.Transhipment')
  }
  static get allDriverStatus() {
    return new ObjectCollection(DeliveryDriverStatus, 'enums.DeliveryDriverStatus')
  }
  static get allTipoVeiculo() {
    return new ObjectCollection(TipoVeiculo, 'enums.TipoVeiculo')
  }
  static get allMarcaVeiculo() {
    return new ObjectCollection(MarcaVeiculo, 'enums.MarcaVeiculo')
  }
  static get allTipoCarroceria() {
    return new ObjectCollection(TipoCarroceria, 'enums.TipoCarroceria')
  }
  static get allEmailNivel() {
    return new WholeCollection(EmailNivel)
  }
  static get allStatusNotificacaoAuditoria() {
    return new WholeCollection(StatusNotificacaoAuditoria)
  }

  static get allTipoNotificacaoCarga() {
    return new ObjectCollection(TipoNotificacaoCarga, 'enums.TipoNotificacaoCarga')
  }

  /**
   * Get period collection
   */
  static getPeriodCollection() {
    const items = this.allPeriod.getMany(availablePeriods as ID[])
    return new ObjectCollection(items)
  }

    static getPeriodCollectionWithNoWeekly() {
        const items = this.allPeriod.getMany(availablePeriodsForSac as ID[])
        return new ObjectCollection(items)
    }

  /**
   * Get period collection
   */
  static getGroupByCollection() {
    const items = this.allGroupBy.getMany(availableGroupBys as ID[])
    return new ObjectCollection(items)
  }

  static getGroupByNoDefaultCollection() {
      const items = this.allGroupByNoDefault.getMany(availableGroupBys as ID[])
      return new ObjectCollection(items)
  }

  /**
   * Get day collection
   * @param dateFormat
   */
  static getDayCollection(dateFormat?: string) {
    const days: IResource[] = []
    const range = moment(dateFormat).daysInMonth()

    for (let i = 0; i < range; i++) {
      days.push({
        $id: i + 1,
        $tag: `${i + 1}`,
      })
    }

    return new ObjectCollection(days)
  }

  /**
   * Get month collection
   */
  static getMonthCollection() {
    const months: IResource[] = []

    for (let i = 0; i <= 11; i++) {
      months.push({
        $id: i + 1,
        $tag: moment().month(i).format('MMMM'),
      })
    }

    return new ObjectCollection(months)
  }

  static getYearList() {
    const years: number[] = []
    const firstDate = moment(AppConfig.firstDate)
    const yearDifference = moment().diff(firstDate, 'year')
    let firstYear = Number(firstDate.year())

    for (let i = yearDifference; i >= 0; i--) {
      years.push(firstYear++)
    }
    years.reverse()

    return years
  }

  /**
   * Get year collection
   */
  static getYearCollection() {
    const years = ItrackCollection.getYearList()

    const items = years.map((year: number) => ({
      $id: year,
      $tag: `${year}`,
    }))
    return new ObjectCollection(items)
  }

  /**
   * Get UF collection
   * @param region
   */
  static getUfCollection(region?: Region | null) {
    let items: IResource[] = this.allUF.items

    if (region === Region.CENTRO_OESTE) {
      items = this.allUF.getMany(centroOesteUFs as ID[])
    } else if (region === Region.NORDESTE) {
      items = this.allUF.getMany(nordesteUFs as ID[])
    } else if (region === Region.NORTE) {
      items = this.allUF.getMany(norteUFs as ID[])
    } else if (region === Region.SUDESTE) {
      items = this.allUF.getMany(sudesteUFs as ID[])
    } else if (region === Region.SUL) {
      items = this.allUF.getMany(sulUFs as ID[])
    }

    return new ObjectCollection(items)
  }

  /**
   * Get UF collection
   */
  static getUfInitialCollection() {
    const items: IResource[] = this.allUFInitial.items
    return new ObjectCollection(items)
  }

}

export const availablePeriods: Period[] = [
  Period.HOURLY,
  Period.DAILY,
  Period.MONTHLY,
  Period.WEEKLY,
]

export const availablePeriodsForSac: Period[] = [
    Period.HOURLY,
    Period.DAILY,
    Period.MONTHLY,
]

export const availableGroupBys: GroupBy[] = [
  GroupBy.VAZIO,
  GroupBy.ID_CARGA,
  GroupBy.CTE,
]

export const centroOesteUFs: UF[] = [
  UF.DISTRITO_FEDERAL,
  UF.GOIAS,
  UF.MATO_GROSSO,
  UF.MATO_GROSSO_DO_SUL,
]

export const nordesteUFs: UF[] = [
  UF.ALAGOAS,
  UF.BAHIA,
  UF.CEARA,
  UF.MARANHAO,
  UF.PARAIBA,
  UF.PERNAMBUCO,
  UF.PIAUI,
  UF.RIO_GRANDE_DO_NORTE,
  UF.SERGIPE,
]

export const norteUFs: UF[] = [
  UF.ACRE,
  UF.AMAPA,
  UF.AMAZONAS,
  UF.PARA,
  UF.RONDONIA,
  UF.RORAIMA,
  UF.TOCANTINS,
]

export const sudesteUFs: UF[] = [
  UF.ESPIRITO_SANTO,
  UF.MINAS_GERAIS,
  UF.RIO_DE_JANEIRO,
  UF.SAO_PAULO,
]

export const sulUFs: UF[] = [
  UF.PARANA,
  UF.RIO_GRANDE_DO_SUL,
  UF.SANTA_CATARINA,
]
